var render = function render(){var _vm=this,_c=_vm._self._c;return _c('K2Row',{staticClass:"k2Radio",attrs:{"align":"center"}},_vm._l((_vm.list),function(item){return _c('el-radio',{attrs:{"label":item},on:{"change":_vm.onChange},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }